/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../../node_modules/ionic-angular/components/nav/nav.ngfactory";
import * as i2 from "ionic-angular/components/split-pane/split-pane";
import * as i3 from "ionic-angular/components/nav/nav";
import * as i4 from "ionic-angular/navigation/view-controller";
import * as i5 from "ionic-angular/navigation/nav-controller";
import * as i6 from "ionic-angular/components/app/app";
import * as i7 from "ionic-angular/config/config";
import * as i8 from "ionic-angular/platform/platform";
import * as i9 from "ionic-angular/gestures/gesture-controller";
import * as i10 from "ionic-angular/transitions/transition-controller";
import * as i11 from "ionic-angular/navigation/deep-linker";
import * as i12 from "ionic-angular/platform/dom-controller";
import * as i13 from "./app.component";
import * as i14 from "@ionic-native/status-bar";
import * as i15 from "@ionic-native/splash-screen";
import * as i16 from "angularfire2/auth";
import * as i17 from "../globals";
import * as i18 from "../pages/auth/services";
import * as i19 from "../pages/providers/services";
import * as i20 from "@ionic-native/screen-orientation";
import * as i21 from "ionic-angular/components/alert/alert-controller";
import * as i22 from "@ionic-native/background-mode";
import * as i23 from "@ngx-translate/core";
import * as i24 from "@ionic-native/network";
import * as i25 from "@ionic-native/native-storage";
import * as i26 from "@ionic-native/device";
import * as i27 from "../pages/services/printServices";
import * as i28 from "../pages/takeaway/services";
import * as i29 from "@ionic-native/push";
import * as i30 from "../pages/services/notificationsServices";
import * as i31 from "@ionic-native/deeplinks";
import * as i32 from "ionic-angular/components/toast/toast-controller";
import * as i33 from "../pages/configuration/services";
var styles_MyApp = [];
var RenderType_MyApp = i0.ɵcrt({ encapsulation: 2, styles: styles_MyApp, data: {} });
export { RenderType_MyApp as RenderType_MyApp };
export function View_MyApp_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 2, "ion-nav", [], null, null, null, i1.View_Nav_0, i1.RenderType_Nav)), i0.ɵprd(6144, null, i2.RootNode, null, [i3.Nav]), i0.ɵdid(2, 4374528, null, 0, i3.Nav, [[2, i4.ViewController], [2, i5.NavController], i6.App, i7.Config, i8.Platform, i0.ElementRef, i0.NgZone, i0.Renderer, i0.ComponentFactoryResolver, i9.GestureController, i10.TransitionController, [2, i11.DeepLinker], i12.DomController, i0.ErrorHandler], { root: [0, "root"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.rootPage; _ck(_v, 2, 0, currVal_0); }, null); }
export function View_MyApp_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_MyApp_0, RenderType_MyApp)), i0.ɵdid(1, 49152, null, 0, i13.MyApp, [i8.Platform, i14.StatusBar, i15.SplashScreen, i16.AngularFireAuth, i17.Globals, i18.AuthServices, i19.ProvidersServices, i8.Platform, i20.ScreenOrientation, i21.AlertController, i6.App, i22.BackgroundMode, i23.TranslateService, i24.Network, i25.NativeStorage, i26.Device, i27.PrintServices, i28.TakeawayServices, i29.Push, i30.NotificationsServices, i31.Deeplinks, i32.ToastController, i33.ConfigurationServices], null, null)], null, null); }
var MyAppNgFactory = i0.ɵccf("ng-component", i13.MyApp, View_MyApp_Host_0, {}, {}, []);
export { MyAppNgFactory as MyAppNgFactory };
//# sourceMappingURL=app.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.ngfactory.js
// module id = null
// module chunks = 